var map = {
	"./boxcom-icon.png": 268,
	"./default-logo.png": 2260,
	"./desktop-icon.png": 363,
	"./dropbox-icon.png": 269,
	"./logo-dark.png": 878,
	"./logo.png": 2261,
	"./no-image-bg.png": 2262,
	"./no-image-qs.png": 2263,
	"./no-image.png": 2264
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2321;



//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.png$
// module id = 2321
// module chunks = 1